import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { editApiKey } from '../../services/ApiKeysService';
import { EditApiKeyRequest, ApiKeyResponse } from '../../models/ApiKeyResponse';

interface ApiKeyExtendProps {
  apiKey: ApiKeyResponse;
  afterSave: () => void;
}

const ApiKeyExtend: React.FC<ApiKeyExtendProps> = ({ apiKey, afterSave }) => {
  const { t } = useTranslation();
  const [apiError, setApiError] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const validityOptions = [
    { label: t('never'), value: undefined },
    { label: t('30Days'), value: 30 },
    { label: t('90Days'), value: 90 },
    { label: t('180Days'), value: 180 },
    { label: t('365Days'), value: 365 },
  ];

  const onSubmit = async (formData: any) => {
    try {
      setApiError(null);
      
      const request: EditApiKeyRequest = { 
        description: apiKey.description || null,
        status: apiKey.status,
        validForDays: formData.validForDays ? parseInt(formData.validForDays) : undefined
      };
      const result = await editApiKey(apiKey.key, request);
      if (result.success) {
        afterSave();
      }
    } catch (error: any) {
      console.error('Failed to extend API key validity:', error);
      setApiError(error.response?.data?.error || t('extendValidityError'));
    }
  };

  const clearApiError = () => {
    setApiError(null);
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)} className="form-box__form">
        <div className="form-box__row">
          <div className="form-box__label">{t('validityPeriod')}:</div>
          <Dropdown
            {...register('validForDays')}
            options={validityOptions}
            placeholder={t('selectValidityPeriod')}
            className="dropdown"
            optionLabel="label"
            optionValue="value"
          />
        </div>
        
        {apiError && (
          <div className="p-error">
            {apiError}
          </div>
        )}

        <Button className="btn btn--sm" label={t('extend')} type="submit" />
      </form>
    </div>
  );
};

export default ApiKeyExtend;
